import React from 'react';

function EmptyNotas(){return<p>¡Crea tu primer TODO!</p>;}

export{EmptyNotas};